import { timeline } from "motion";
import {
  getAnimatingContainers,
  getAnimationSequenceToMorphBetweenElements,
  animateForward,
  animateBackwards,
} from "./scripts-utils";

export const HomeToProjectAnimation = {
  from: "/",
  to: "/project/:id",

  // Neuer Content wird eingefügt
  in: async () => {
    // if no slider element is found, do nothing
    if (!window.luther?.projectSlider?.instance) {
      return;
    }

    // get new and old container
    const { next, prev } = getAnimatingContainers();

    // prev elementss
    const sliderElement = prev.querySelector(".luther-project-slider__slider");
    const clickedSlide = prev.querySelector(".is-tranforming-to-main-image");
    const otherSlides = sliderElement.querySelectorAll(
      ".swiper-slide:not(.is-tranforming-to-main-image)",
    );
    const slideImage = clickedSlide.querySelector(".project-slide__image");
    const projectTitel = prev.querySelector(".luther-project-slider__title");

    // next elements
    const nextHeaderImage = next.querySelector(".luther-project-header__image");

    // prepare leaving container
    prev.style.position = "absolute";
    prev.style.zIndex = "-1";
    prev.style.top = "0";
    prev.style.left = "0";
    prev.style.overflow = "hidden";
    sliderElement.style.overflow = "visible";

    // duration faktor
    const f = 0.5;

    // Verhindert dass der Slider sich nun noch bewegt
    window.luther.projectSlider.instance.disable();
    window.luther.projectSlider.instance.detachEvents();

    // animate
    const sequence = [
      [
        slideImage,
        getAnimationSequenceToMorphBetweenElements(slideImage, nextHeaderImage),
        { at: 0.1, duration: 1 * f },
      ],
      [otherSlides, { opacity: [1, 0] }, { at: 0, duration: 1 * f }],
      [projectTitel, { opacity: [1, 0] }, { at: 0, duration: 0.5 * f }],
      [
        next,
        { opacity: [0, 1] },
        { at: Math.max(f - 0.5 * f, 0.5), duration: 0.5 * f },
      ],
    ];

    await timeline(sequence).finished;
  },
};

/**
 * Erst mal scrollt er nur zu dem Projekt aber er animiert noch nix
 */
export const ProjectToHomeAnimation = {
  from: "/project/:id",
  to: "/",
  in: async (done, data) => {
    // if no slider element is found, do nothing
    if (!window.luther?.projectSlider?.instance) {
      return;
    }

    // get index of target slide
    const slideLinks = window.luther.projectSliderData.map(
      (slide) => slide.permalink,
    );

    const targetSlideIndex = slideLinks.indexOf(data.from.url);

    if (targetSlideIndex == -1) {
      console.error("Page transition failed.");
      return;
    }

    // set slide position to the one before the last page visit
    window.luther.projectSlider.instance.slideTo(targetSlideIndex, 0);

    // get new and old container
    const { next, prev } = getAnimatingContainers();

    await animateBackwards(prev, next);
  },
};

export const DefaultTransition = {
  from: "(.*)",
  to: "(.*)",
  in: async () => {
    const { next, prev } = getAnimatingContainers();

    await animateForward(prev, next);
  },
};
